import { CONTACT_SALES_FROM_STICKY_BUTTON_TEST_LINK } from "constants/links";
import PictureComponent from "/components/core/picture/picture-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import {
  CONTACT_SALES_STICKY_BUTTON_CLICKED,
  CONTACT_SALES_STICKY_BUTTON_IS_VISIBLE
} from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import classNames from "classnames";
import { StyledContactSalesStickyButton } from "./contact-sales-sticky-button.scss";

const CONTACT_SALES_ICON =
  "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/contact-sales-icon-v3.png";

const ContactSalesStickyButton = (props) => {
  const { translate, showButton } = props;

  const shouldShowButton = () => {
    if (showButton) trackEvent(CONTACT_SALES_STICKY_BUTTON_IS_VISIBLE);
    return showButton;
  };

  const onClick = () => {
    trackEvent(CONTACT_SALES_STICKY_BUTTON_CLICKED);
  };

  return (
    <StyledContactSalesStickyButton
      className={classNames("contact-sales-sticky-button-component", {
        "is-visible": shouldShowButton()
      })}
      onClick={onClick}
    >
      <a href={CONTACT_SALES_FROM_STICKY_BUTTON_TEST_LINK} className="contact-sales-sticky-button">
        <PictureComponent src={CONTACT_SALES_ICON} />
        {translate("header.contactSales")}
      </a>
    </StyledContactSalesStickyButton>
  );
};

export default withGenericConfig(ContactSalesStickyButton);
